import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Phone, User, Users } from 'lucide-react';

export interface ImmediateContact {
    name: string;
    phone: string;
    relation: string;
}

interface ImmediateContactFormProps {
    data: ImmediateContact;
    onChange: (data: ImmediateContact) => void;
}

const ImmediateContactForm: React.FC<ImmediateContactFormProps> = ({ data, onChange }) => {
    const handleChange = (field: keyof ImmediateContact, value: string) => {
        onChange({ ...data, [field]: value });
    };

    const isValidPhone = (phone: string) => {
        const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
        return phone === '' || phoneRegex.test(phone.replace(/[\s\-\(\)]/g, ''));
    };

    return (
        <Card className="w-full">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Users className="h-5 w-5" />
                    Immediate Contact Person
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                        <Label htmlFor="contactName">Name *</Label>
                        <div className="relative">
                            <User className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                            <Input
                                id="contactName"
                                placeholder=""
                                value={data.name || ''}
                                onChange={(e) => handleChange('name', e.target.value)}
                                className="pl-10"
                            />
                        </div>
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="contactPhone">Phone Number *</Label>
                        <div className="relative">
                            <Phone className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                            <Input
                                id="contactPhone"
                                type="tel"
                                placeholder=""
                                className={`pl-10 ${data.phone && !isValidPhone(data.phone) ? 'border-red-500 focus:border-red-500' : ''}`}
                                value={data.phone || ''}
                                onChange={(e) => handleChange('phone', e.target.value)}
                            />
                        </div>
                        {data.phone && !isValidPhone(data.phone) && (
                            <p className="text-sm text-red-600">Please enter a valid phone number</p>
                        )}
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="contactRelation">Relation *</Label>
                        <Input
                            id="contactRelation"
                            placeholder=""
                            value={data.relation || ''}
                            onChange={(e) => handleChange('relation', e.target.value)}
                        />
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default ImmediateContactForm;
